import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getDistributorByUUID, updateDistributor } from 'app-support/licenses/state/actions'
import { IDistributor, TLicenseTypeValues } from '@cbgms/api'
import { enumToOptions } from '@cbgms/base/utils/helpers'
import { LicenseType } from '@carsys/enums/license-type'
import { isRequired } from '@cbgms/base/utils/validations'
import OptionalLicenseFields from '../components/OptionalLicenseFields'
import { IRootReducerState } from 'state/reducers'
import { useNotifier } from '@cbgms/base/notifier'
import FormikFormLayout from 'core/page/layout/FormikFormLayout'
import { Form } from '@carsys/form'
import { Dropdown } from '@carsys/form/src/Dropdown'
import { TextField } from '@carsys/form/src/TextField'
import Box from '@mui/material/Box'
interface IFormValues {
  Name: string
  LicenseType: TLicenseTypeValues
  [key: string]: any
}

const EditDistributor = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const notifier = useNotifier()
  const [initialValues, setInitialValues] = useState<IFormValues | null>(null)
  const { distributorUUID } = useParams<{ distributorUUID?: string }>()
  const distributor = useSelector<IRootReducerState, IDistributor | null>(state => state.distributor)
  const options = enumToOptions(LicenseType, 'EnumLicenseType')

  useEffect(() => {
    if (distributorUUID) {
      dispatch(getDistributorByUUID(distributorUUID))
    }
  }, [distributorUUID])

  useEffect(() => {
    if (distributor && distributor.Name) {
      const { CreatedAt, UpdatedAt, ...formValues } = distributor
      setInitialValues(formValues)
    }
  }, [distributor])

  const onSubmitSuccess = () => {
    notifier.success(t('Distributor.SuccessfullyUpdated'))
  }

  const handleSubmit = async (values: IFormValues) => {
    try {
      const { Data } = await dispatch(updateDistributor(distributorUUID!, values))
      return { ...Data, ...values } as IFormValues
    } catch (e) {
      throw e
    }
  }
  if (!initialValues) return null

  return (
    <Form<IFormValues, IFormValues>
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
      onSubmitSuccess={onSubmitSuccess}
    >
      {formikBag => {
        return (
          <FormikFormLayout backButtonProps={{ to: '/licenses/distributors' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ maxWidth: 300 }}>
                <TextField validate={isRequired} required name='Name' data-testid='input-name' label={t('distributor.name')} />
              </Box>
              <Box sx={{ maxWidth: 300 }}>
                <Dropdown
                  data-testid='dropdown-licensetype'
                  validate={isRequired}
                  required
                  label={t('distributor.licensetype')}
                  name='LicenseType'
                  options={options}
                />
              </Box>
              <Box>{formikBag.values.LicenseType && <OptionalLicenseFields licenseType={formikBag.values.LicenseType} />}</Box>
            </Box>
          </FormikFormLayout>
        )
      }}
    </Form>
  )
}

export default EditDistributor
